<div class="container destaques-posts" *ngIf="principalPost && restantesPosts">
  <header>
    <h2 class="link-orange">Destaques</h2>
  </header>
  <div class="row">
    <div class="post-principal col-md-8">
      <img
        class="img-fluid"
        [src]="env.origin + '/blogmidias/' + principalPost.postId + '.jpg'"
        [alt]="principalPost.altImg"
      />
      <div class="col-md-12">
        <div class="footer">
          <div class="d-flex">
            <!-- <span class="category-post">{{ principalPost.category[0] }}</span> -->
            <!-- <span
              *ngIf="principalPost.category.length > 1"
              class="category-post count"
            >
              {{ '+' + (principalPost.category.length - 1) }}</span
            > -->
          </div>
          <span class="date-post">{{
            parseDate(principalPost.date) | date : 'dd/MM/yyyy'
          }}</span>
        </div>

        <div class="py-3 px-2">
          <h2>
            <a
              target="_blank"
              class="link"
              [routerLink]="['/blog', principalPost.postId]"
              >{{ principalPost.title }}</a
            >
          </h2>
          <p class="description-post">{{ principalPost.description }}.</p>
          <div>
            <a
              target="_blank"
              class="btn btn-primary"
              [routerLink]="['/blog', principalPost.postId]"
              >Leia mais!</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 container-list-posts">
      <div class="list-posts">
        <div *ngFor="let post of restantesPosts">
          <!-- <div
            [style.backgroundImage]="
              'url(' + env.origin + '/blogmidias/' + post.postId + '.jpg' + ')'
            "
            class="list"
          ></div> -->
          <img
            class="list"
            [src]="env.origin + '/blogmidias/' + post.postId + '.jpg'"
            [alt]="post.altImg"
          />
          <div>
            <div class="d-flex container-footer">
              <div>
                <!-- <span class="category-post">{{ post.category[0] }}</span> -->
                <!-- <span
                  *ngIf="post.category.length > 1"
                  class="category-post count"
                >
                  {{ '+' + (post.category.length - 1) }}</span
                > -->
              </div>
              <span class="date">{{ parseDate(post.date) | date : 'dd/MM/yyyy' }}</span>
            </div>
            <p class="mt-2">
              <a
                target="_blank"
                style="font-size: 1.25rem"
                class="link"
                [routerLink]="['/blog', post.postId]"
                >{{ post.title }}</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
